import { ReactNode } from 'react'
import { clsx } from 'clsx'

interface Props {
  open: boolean
  children: ReactNode
  side: 'left' | 'right' | 'top' | 'bottom'
}

export function Drawer({ open, children, side }: Props) {
  return (
    // <div className="absolute inset-0 overflow-hidden">
    <div className="overflow-hidden">
      <div className={clsx('pointer-events-none fixed max-w-full', classNames[side])}>
        <div
          className={clsx(
            'pointer-events-auto relative w-full h-full transform transition ease-in-out duration-500',
            { [closeClassNames[side]]: !open },
            { [openClassNames[side]]: open }
          )}
          onClick={(event) => {
            event.preventDefault()
            event.stopPropagation()
          }}
        >
          <div className={clsx('flex flex-col h-full overflow-hidden bg-white')}>{children}</div>
        </div>
      </div>
    </div>
  )
}

const openClassNames = {
  right: 'translate-x-0',
  left: 'translate-x-0',
  top: 'translate-y-0',
  bottom: 'translate-y-0',
}

const closeClassNames = {
  right: 'translate-x-full',
  left: '-translate-x-full',
  top: '-translate-y-full',
  bottom: 'translate-y-full',
}

const classNames = {
  right: 'inset-y-0 right-0',
  left: 'inset-y-0 left-0',
  top: 'inset-x-0 top-0',
  bottom: 'inset-x-0 bottom-0',
}
